<template>
  <div
    class="tab"
    :class="{'tab__active': tab.name === lastSelectedDateTab}"
    @click.prevent="changeTab(tab.name)"
  >
    <span>{{ tab.name | moment('M月D日(dd)') }}</span>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    tab: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState([
      'dateTab',
      'lastSelectedDateTab'
    ])
  },
  methods: {
    ...mapMutations([
      'setDateTab'
    ]),
    changeTab (date) {
      this.$store.state.lastSelectedDateTab = date
      this.setDateTab(date)
    }
  }
}
</script>

<style lang="sass" scoped>
.tab
  display: flex
  justify-content: center
  align-items: center
  width: 50%
  height: 45px
  background-color: $lightgray
  font-size: 15px
  font-weight: bold
  cursor: pointer
  span
    color: $gray
    padding: 10px
  &__active
    background-color: #fff
    span
      color: $green
      border-bottom: 2px solid $green
</style>
